// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import type { SchemaModel } from '../../models/Schema'

/**
 * Placeholder orgId used in built-in seed schemas.
 * Replaced with the real orgId by the seed runner at initialization time.
 */
export const SEED_ORG_PLACEHOLDER = '__SEED_ORG__'

/**
 * Placeholder workspaceId used in built-in seed schemas.
 * Replaced with the real workspaceId by the seed runner at initialization time.
 */
export const SEED_WORKSPACE_PLACEHOLDER = '__SEED_WORKSPACE__'

/**
 * A seed schema is a SchemaModel without the auto-generated fields that
 * the seed runner fills in (id, createdAt, updatedAt).
 */
export type SeedSchema = Omit<SchemaModel, 'id' | 'createdAt' | 'updatedAt'>
